import React from "react";
import {
  Autocomplete,
  Box,
  FormHelperText,
  Grid,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import AddCircleIcon from "@mui/icons-material/AddCircle";

// Cliente (sólo lectura), dirección de entrega del cliente y accesos a
// agregar coordenadas / agregar dirección. Mismo diseño que el original.
export default function EncabezadoEditar({
  cliente,
  direcciones,
  direccionSeleccionada,
  onDireccionChange,
  mostrarAgregarCoordenadas,
  onAgregarCoordenadas,
  onNuevaDireccion,
}) {
  return (
    <>
      <Grid item xs={6}>
        <TextField
          label="Cliente"
          name="cliente"
          size="small"
          focused
          required
          fullWidth
          autoComplete="off"
          value={cliente}
        />
      </Grid>

      <Grid item xs={5.5}>
        <Autocomplete
          disabled={!direcciones}
          required
          disableClearable
          id="direccion"
          style={{ backgroundColor: "#ffffff", width: "100%" }}
          size="small"
          noOptionsText={"Direccion INEXISTENTE"}
          options={direcciones || []}
          autoHighlight
          getOptionLabel={(direccion) => direccion.direccion_entrega}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          value={direccionSeleccionada || null}
          onChange={(event, value) => onDireccionChange(value)}
          renderOption={(props, option) => (
            <Box
              component="li"
              key={option.id}
              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              {option.direccion_entrega}
            </Box>
          )}
          renderInput={(params) => (
            <TextField
              placeholder="Tipee para buscar..."
              {...params}
              label="Direccion"
              focused
              inputProps={{ ...params.inputProps }}
            />
          )}
        />
        {mostrarAgregarCoordenadas ? (
          <FormHelperText sx={{ bgcolor: "lemonchiffon", color: "#5D6D7E" }}>
            La Dirección de Entrega no tiene coordenadas, para agregarlas pulse "Agregar
            Coordenadas"
          </FormHelperText>
        ) : null}
      </Grid>

      {mostrarAgregarCoordenadas ? (
        <Grid item xs={0.5}>
          <Tooltip title="Agregar coordenadas">
            <IconButton color="secondary" onClick={onAgregarCoordenadas}>
              <AddLocationAltIcon />
            </IconButton>
          </Tooltip>
        </Grid>
      ) : null}
      <Grid item xs={0.5}>
        <Tooltip title={`Agregar direccion a ${cliente}`}>
          <IconButton color="primary" onClick={onNuevaDireccion}>
            <AddCircleIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    </>
  );
}
